import Button from "atoms/buttons/button";
import ConversationRecord from "models/view-models/conversations/conversation-record";
import React, { useEffect, useRef, useState } from "react";
import Tooltip, { TooltipPlacement } from "molecules/tooltips/tooltip";
import { ButtonStyles } from "atoms/constants/button-styles";
import useNetworkInformation from "utilities/contexts/network-information/use-network-information";
import ChatOfflineTooltipContent from "organisms/modals/chat-modal/chat-offline-tooltip-content";

const ChatTooltipButton: React.FC<{
    conversation: Omit<ConversationRecord, "messages">;
    onLoadConversation: (id?: string) => void;
}> = ({ conversation, onLoadConversation }) => {
    const buttonRef = useRef<HTMLButtonElement>(null);
    const [showTooltip, setShowTooltip] = useState(false);
    const { isOnline } = useNetworkInformation();

    useEffect(() => {
        const checkTruncation = () => {
            const element = buttonRef.current;
            if (element) {
                setShowTooltip(element.scrollWidth > element.clientWidth);
            }
        };

        checkTruncation();
        window.addEventListener("resize", checkTruncation);
        return () => window.removeEventListener("resize", checkTruncation);
    }, [conversation.title]);

    const handleLoadConversation = () => {
        if (!isOnline) {
            return;
        }

        onLoadConversation(conversation.id);
    };

    const tooltipDisabled = !showTooltip && isOnline;

    return (
        <Tooltip
            disabled={tooltipDisabled}
            content={
                isOnline ? conversation.title : <ChatOfflineTooltipContent />
            }
            hideOnClick={true}
            durationInMs={0}
            placement={TooltipPlacement.Bottom}>
            <Button
                ref={buttonRef}
                key={conversation.id}
                style={ButtonStyles.Anchor}
                onClick={handleLoadConversation}>
                {conversation.title}
            </Button>
        </Tooltip>
    );
};

export default ChatTooltipButton;
